import Axios from 'axios';
import { protectedResources } from '../authConfig';
import { cachedRequest, readCachedValue, ATTENDANCE_CACHE_MS } from '../helpers/cachedRequest';

const URL =
  protectedResources.apiHRMobile.baseApi + '/api/v1/TimeInOut/GetTimeInOutInfo';
let tokenKey;

const pad = (n) => String(n).padStart(2, '0');

const cacheKey = (email, periodOffset) =>
  `attendance_timeinout_v2_${(email || '').toLowerCase()}_${periodOffset}`;

// What was loaded before for this period (any age), or undefined. Lets a page paint at once.
export function peekTimeInOut(email = '', periodOffset = 0) {
  return readCachedValue(cacheKey(email, periodOffset));
}

/**
 * One pay period of time in/out. periodOffset 0 = the current period (16th up to today), -1 = the period
 * before it (16th to 15th), -2 = the one before that, and so on. A period that does not exist comes back with
 * an empty list, not an error. The request is shared with other callers of the same period, so it is not
 * cancellable; callers drop the answer they no longer need instead.
 */
export async function getTimeInOutPeriod(email = '', periodOffset = 0) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
    params: { emailOrId: email, periodOffset }
  };

  try {
    return await cachedRequest(
      cacheKey(email, periodOffset),
      ATTENDANCE_CACHE_MS,
      async () => (await Axios.get(URL, config)).data
    );
  } catch (error) {
    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    throw error;
  }
}

// First period only (the current one); kept for callers that just warm the cache.
export function getTimeInOutLastMonth(email = '') {
  return getTimeInOutPeriod(email, 0);
}

// Pay periods run from the 16th to the 15th. The current period (offset 0) ends today, because there is no data
// after it; older ones end on the 15th.
export function payPeriodDates(periodOffset = 0, today = new Date()) {
  const start = new Date(
    today.getFullYear(),
    today.getMonth() - (today.getDate() >= 16 ? 0 : 1) + periodOffset,
    16
  );
  const end =
    periodOffset === 0 ? today : new Date(start.getFullYear(), start.getMonth() + 1, 15);
  return { start, end };
}

// The dates shown in the table heading, e.g. "16/10/2026 - 04/11/2026".
export function payPeriodRange(periodOffset = 0, today = new Date()) {
  const { start, end } = payPeriodDates(periodOffset, today);
  const fmt = (d) => `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  return `${fmt(start)} - ${fmt(end)}`;
}
